import { Button, Pill } from '@at/design-system-elements'
import { BREAKPOINTS } from '@at/window-utils'
import styled, { css } from 'styled-components'

export const StyledFilterButton = styled(Button)<{
    $selectedFilterCount?: number | null
    $showButtonMobile?: boolean
}>`
    ${({ $selectedFilterCount, theme }) => {
        return css`
            min-width: 180px;
            min-height: 52px;

            &.search-filter-cta {
                transition: none;
                font-size: 14px;
                &:focus,
                &:focus-visible {
                    outline: ${({ theme }) => `2px solid ${theme.color.border.focus}`};
                }
            }
            & > span {
                position: relative;
                &:before {
                    content: '${$selectedFilterCount}';
                    border-radius: 100%;
                    position: absolute;
                    top: -4px;
                    left: -9px;
                    background-color: ${theme.color.bgFill.notification};
                    color: ${theme.color.text.intense.onFill};
                    font-size: 0.6rem;
                    line-height: 1.5;
                    padding: auto;
                    text-align: center;
                    ${$selectedFilterCount == 0 ? `display: none;` : `display: block`};
                    width: 13px;
                    height: 13px;
                }
            }
            @media (max-width: ${BREAKPOINTS.MEDIUM - 1}px) {
                display: none;
            }
        `
    }}
`

export const StyledATDSPill = styled(Pill)<{ $showNewBadge?: boolean }>`
    ${({ $showNewBadge }) => {
        if ($showNewBadge) {
            return css`
                position: relative;
                &:before {
                    content: 'New';
                    position: absolute;
                    top: -6px;
                    right: 10px;
                    display: block;
                    height: 22px;
                    background-color: #0c1233ff;
                    color: #ffffffff;
                    font-size: 12px;
                    line-height: 16px;
                    border-radius: 4px;
                    display: flex;
                    font-variation-settings: 'wght' 500;
                    padding: 4px 8px;
                }
            `
        }
    }}
`
